<template>
  <b-card
    v-if="selectedYear"
    no-body
    class="card-revenue-budget card-transaction h-100"
  >
    <b-row class="mx-0">
      <b-col
        md="8"
        class="revenue-report-wrapper"
      >
        <div class="d-sm-flex justify-content-between align-items-center mb-2">
          <h4 class="card-title mb-50 mb-sm-0">
            {{ $t('Applied year count') }}
          </h4>
        </div>
        <div
          v-for="(count, dc_type) in getDctypesOfYear().dc_types"
          :key="dc_type"
          class="transaction-item"
        >
          <b-media no-body>
            <b-media-body>
              <h6 class="transaction-title">
                {{ $langName(getDcType(Number(dc_type)).name) }}
              </h6>
            </b-media-body>
          </b-media>
          <div
            class="font-weight-bolder text-primary"
          >
            {{ count }}
          </div>
        </div>
      </b-col>

      <b-col
        md="4"
        class="budget-wrapper"
      >
        <b-form-select
          v-model="selectedYear"
          size="sm"
          class="budget-dropdown"
          variant="outline-primary"
          :options="list"
          value-field="year"
          text-field="year"
        />

        <h2 class="mb-25">
          {{ $t('Total') }}: {{ getTotal() }}
        </h2>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BFormSelect,
  BMedia, BMediaBody,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormSelect,
    BMedia,
    BMediaBody,
  },
  directives: {
    Ripple,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedYear: null,
    }
  },
  mounted() {
    if (this.list[0]) this.selectedYear = this.list[0].year
  },
  methods: {
    getTotal() {
      let total = 0
      const item = this.getDctypesOfYear()
      Object.values(item.dc_types).forEach(val => {
        total += val
      })
      return total
    },
    getDctypesOfYear() {
      return this.list.find(item => item.year === this.selectedYear)
    },
    getDcType(id) {
      return this.$store.getters['staticModule/getDcType'](id)
    },
  },
}
</script>
